import { render, staticRenderFns } from "./wxAuth.vue?vue&type=template&id=61c92e28&scoped=true"
import script from "./wxAuth.vue?vue&type=script&lang=js"
export * from "./wxAuth.vue?vue&type=script&lang=js"
import style0 from "./wxAuth.vue?vue&type=style&index=0&id=61c92e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c92e28",
  null
  
)

export default component.exports